import { Modal, Image } from 'antd';
import { useRef, useState, useEffect } from 'react';
import heart from '../../assets/imgage/wordBook/heart.png';
import coin from '../../assets/imgage/wordBook/coin.png';

const ModalSuccess = ({
    isOpen = false,
    onOk,
    onClose,
    pointType,
    pointEarn
}) => {

    useEffect(() => {
    }, []);

    return (
        <Modal
            open={isOpen}
            onCancel={onClose}
            footer={null}
            closable={false}
            width={375}
            className="custom-wordbook-success-modal {
"
        >
            <div className="bInner">
                <div className="bDetails">
                    {pointType === 'heart' ?
                        <>
                            <Image style={{ width: '70%' }} preview={false} src={heart}>
                            </Image>
                            <h2>ว้าว! คุณได้รับหัวใจ {pointEarn} ดวง</h2>
                            <p>อย่าลืมสะสมหัวใจให้ครบ 10 ดวง</p>
                            <p>เพื่อแลกของรางวัลเลย!</p>
                        </> :
                        <>
                            <Image style={{ width: '70%' }} preview={false} src={coin}>
                            </Image>
                            <h2>ยินดีด้วย! คุณได้รับ {pointEarn} Point</h2>
                            <p>คุณได้รับหัวใจครบ 10 ดวงแล้ว</p>
                            <p>จะได้รับเป็น Point แทน</p>
                        </>
                    }
                    <button className='confirmBtn' onClick={onOk}>ตอบคำถามอีก</button>
                    <button className='cancelBtn' onClick={onClose}>กลับไปหน้าหลัก</button>
                </div>
            </div>
        </Modal>
    );
};

export default ModalSuccess;
